<template>
  <div>
    <SessionDetail v-if="appType == 'session'"></SessionDetail>
    <SessionDetailCan v-bind:settingsPerm="settingsPerm" v-if="appType == 'sessions'"></SessionDetailCan>
    <SpeakerDetail v-if="appType == 'speakerdetail'"></SpeakerDetail>
    <ExpertDetail v-bind:settingsPerm="settingsPerm" v-if="appType == 'expertDetailVue'"></ExpertDetail>
    <ProgramDisplay v-bind:settingsPerm="settingsPerm" v-if="appType == 'programdisplay'"></ProgramDisplay>
    <SpeakerListing v-bind:settingsPerm="settingsPerm" v-if="appType == 'speakers'"></SpeakerListing>
    <SponsorsDisplay v-bind:settingsPerm="settingsPerm" v-if="appType == 'sponsorsDisplay'"></SponsorsDisplay>
    <SessionsDisplayedInBlog v-bind:settingsPerm="settingsPerm" v-if="appType == 'SessionsInBlog'"></SessionsDisplayedInBlog>
    <SpeakersDisplayedInBlog v-bind:settingsPerm="settingsPerm" v-if="appType == 'SpeakersInBlog'"></SpeakersDisplayedInBlog>
    <SpecialDaysDisplay v-bind:settingsPerm="settingsPerm" v-if="appType == 'SpecialDays'"></SpecialDaysDisplay>
    <IframeDisplay v-bind:settingsPerm="settingsPerm" v-if="appType == 'IframeDisplay'"></IframeDisplay>
    <SpecialDayDetailTop v-bind:settingsPerm="settingsPerm" v-if="appType == 'SpecialDaysDetailsTop'"></SpecialDayDetailTop>
    <SpecialDaysDetails v-bind:settingsPerm="settingsPerm" v-if="appType == 'SpecialDaysDetails'"></SpecialDaysDetails>
    <BrandsAtd v-bind:settingsPerm="settingsPerm" v-if="appType == 'brandsAtdDisplay'"></BrandsAtd>
    <ImpressionSlidingText v-bind:settingsPerm="settingsPerm" v-if="appType == 'impressionTextSectionPB'"></ImpressionSlidingText>
    <CompanyLogo v-bind:settingsPerm="settingsPerm" v-if="appType == 'companyLogoSectionPB'"></CompanyLogo>
    <vueChartDisplay v-bind:settingsPerm="settingsPerm" v-if="appType == 'vueChartDisplay'"></vueChartDisplay>


    <div v-if="settingsPerm && settingsPerm.displayType && settingsPerm.displayType == 'brandComplexes'">
        <brandMain v-bind:settingsPerm="settingsPerm"></brandMain>
    </div>

  </div>
</template>

<script>
import SpeakerListing from './components/SpeakerListing.vue';
import SessionDetail from './components/SessionDetail.vue';
import SessionDetailCan from './components/SessionDetailCan.vue';
import SpeakerDetail from './components/SpeakerDetail.vue';
import ProgramDisplay from './components/ProgramDisplay.vue';
import SponsorsDisplay from './components/SponsorsDisplay.vue';
import SessionsDisplayedInBlog from './components/SessionsDisplayedInBlog.vue';
import SpeakersDisplayedInBlog from './components/SpeakersDisplayedInBlog.vue';
import ExpertDetail from './components/ExpertDetail.vue';
import SpecialDaysDisplay from './components/SpecialDaysDisplay.vue';
import IframeDisplay from './components/IframeDisplay.vue';
import SpecialDaysDetails from './components/SpecialDaysDetails.vue';
import SpecialDayDetailTop from './components/SpecialDayDetailTop.vue';
import BrandsAtd from './components/BrandsAtd.vue';
import ImpressionSlidingText from './components/ImpressionSlidingText.vue';
import CompanyLogo from './components/CompanyLogo.vue';
import vueChartDisplay from './components/ParticipationChart.vue';
import brandMain from './components/brand/BrandMain.vue';

export default {
  name: 'App',
  props: {
    appType: String,
    settings:String
  },
  components: {
    SpeakerListing,
    SessionDetail,
    SpeakerDetail,
    ProgramDisplay,
    SponsorsDisplay,
    ImpressionSlidingText,
    CompanyLogo,
    SessionDetailCan,
    SessionsDisplayedInBlog,
    SpeakersDisplayedInBlog,
    ExpertDetail,
    SpecialDaysDisplay,
    IframeDisplay,
    SpecialDaysDetails,
    SpecialDayDetailTop,
    BrandsAtd,
    vueChartDisplay,
    brandMain
  },
  data(){
    const regEx = new RegExp('%30', "g");
    var settingsData = this.settings.replace(regEx, '"');
    
    return{
      settingsPerm:JSON.parse(settingsData),
    }
  },
  created() {
    if (window.jQuery && window.jQuery.cookie("pll_language")) {
      let cookieLanguage = window.jQuery.cookie("pll_language");
      this.$i18n.locale = cookieLanguage; 
    }
  },
  methods: {
  
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
